import React, {Component} from 'react';
import {Context} from "context";
import {COPY} from "text/errors";

import styles from 'components/versionBanner/versionBanner.module.scss';

/**
 * A bar fixed at the top of the page while the server serves a newer build than the one running (context.updateAvailable). Reload loads it.
 */
export default class VersionBanner extends Component {
    static contextType = Context;

    reload = () => window.location.reload();

    render() {
        if (!this.context.updateAvailable) return null;
        return (
            <div className={styles.banner} role="status">
                <span>{COPY.versionBanner}</span>
                <button type="button" onClick={this.reload}>{COPY.reload}</button>
            </div>
        );
    }
}
